import { useEffect, useState } from "react";
import styles from "../prospectdetails.module.css";
import { Bell, Edit2, Lock, MoreVertical, Plus, Trash2, X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Checkbox, FormControlLabel, TextField } from "@mui/material";
import Loader from "../../../components/Loader";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { Dropdown } from "react-bootstrap";
import { AddLogCallAPI } from "../../../components/AddLogs";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import dayjs from "dayjs";
import FollowUpList from "./follow-up/FollowUpList";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

const TaskTab = (props) => {
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [taskList, setTaskList] = useState([]);
  const [showSubmitButtonNew, setShowSubmitButtonNew] = useState(false);
  const [newTaskName, setNewTaskName] = useState("");
  const [openAddTaskModal, setOpenAddTaskModal] = useState(false);
  const [isShowInlineEdit, setShowInlineEdit] = useState(false);
  const [isShowAddAction, setShowAddAction] = useState(false);
  const [editTaskData, setEditTaskData] = useState(null);
  const [openTaskDeleteModal, setOpenTaskDeleteModal] = useState(false);
  const [deleteTaskId, setDeleteTaskId] = useState(0);

  useEffect(() => {
    if (props?.prospectData?.task_list) {
      let taskListTemp = props?.prospectData?.task_list?.map((i) => {
        return {
          id: i?.id,
          task_name: i?.task_name,
          is_checked: i?.is_checked,
          order: i?.order,
          completed_at: i?.completed_at,
          is_primary: i?.is_primary,
        };
      });

      setTaskList(taskListTemp);
    }
  }, [props?.prospectData?.task_list]);

  const deleteConfirm = async () => {
    setOpenDeleteModal(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_APPLICANT_API_URL + "v1/applicants/" + props?.prospectData?.applicant_id + "/tours/" + deleteId, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setLoading(false);

      props?.setSnackbarMsg(response.data.message);
      props?.setSnackbarOpen(true);

      let allTours = props?.prospectData?.tours?.filter((item) => item.id !== deleteId);

      props.updateTourList(allTours);
      setDeleteId(0);

      let logData = {
        title: "A prospect tour is deleted",
        description: [
          "Name: " + props?.prospectData?.all_applicants[0]?.full_name,
          "Email: " + props?.prospectData?.all_applicants[0]?.email,
          "Phone: " + props?.prospectData?.all_applicants[0]?.phone,
          "Date/Time: " +
          response.data.data?.formatted_date +
          " " +
          response.data.data?.formatted_time,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const cngTourCheck = async (id, e) => {
    let postData = {};
    if (e.target.checked) {
      postData = { is_completed: 1 };
    } else {
      postData = { is_completed: 0 };
    }
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.put(process.env.REACT_APP_APPLICANT_API_URL + "v1/applicants/" + props?.prospectData?.applicant_id + "/tours/" + id, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      props?.setSnackbarMsg(response.data.message);
      props?.setSnackbarOpen(true);

      let tourlist = props?.prospectData?.tours;
      tourlist = tourlist?.map((item) => {
        if (id === item?.id) {
          return response.data.data;
        }
        return item;
      });
      props.updateTourList(tourlist);

      props?.setFollowUpList(response.data?.followUpList);

      let logData = {
        title: "A prospect tour is completed",
        description: [
          "Name: " + props?.prospectData?.all_applicants[0]?.full_name,
          "Email: " + props?.prospectData?.all_applicants[0]?.email,
          "Phone: " + props?.prospectData?.all_applicants[0]?.phone,
          "Date/Time: " +
          response.data.data?.formatted_date +
          " " +
          response.data.data?.formatted_time,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
    });
  }

  const checkChagneNew = (event, item) => {
    setShowSubmitButtonNew(true);

    setTaskList((prev) => {
      return prev?.map((i) => {
        if (i === item) {
          if (event.target.checked) {
            return { ...i, is_checked: 1, completed_at: dayjs() };
          } else {
            return { ...i, is_checked: 0, completed_at: dayjs() };
          }
        }
        return i;
      });
    });
  };

  const changeTaskList = async () => {
    setShowSubmitButtonNew(false);
    let postData = taskList;
    setLoading(true);
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    axios
      .post(
        process.env.REACT_APP_APPLICANT_API_URL + "v1/update-task-list",
        { task_list: JSON.stringify(postData) },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        let respData = response.data.data;
        props.updateTaskList(respData);
        props?.setSnackbarMsg(response.data.message);
        props?.setSnackbarOpen(true);
      })
      .catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  const addNewTask = async () => {
    if (newTaskName === "") {
      toast.error("Please enter task name.");
      return false;
    }
    setOpenAddTaskModal(false);
    setShowInlineEdit(false);
    setShowAddAction(false);
    setLoading(true);
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    if (editTaskData) {
      axios
        .put(
          process.env.REACT_APP_APPLICANT_API_URL +
          "v1/update-task/" +
          editTaskData?.id,
          { task_name: newTaskName },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          let respData = response.data.data;

          let newTaskList = taskList?.map((i) => {
            if (i?.id === editTaskData?.id) {
              return respData;
            }
            return i;
          });

          props.updateTaskList(newTaskList);
          setNewTaskName("");
          setEditTaskData(null);
          props?.setSnackbarMsg(response.data.message);
          props?.setSnackbarOpen(true);
        })
        .catch((error) => {
          if (typeof error.response !== "undefined")
            toast.error(error.response.data.message);
          setLoading(false);
        });
    } else {
      axios
        .post(
          process.env.REACT_APP_APPLICANT_API_URL +
          "v1/add-task-list/" +
          props?.prospectData?.id,
          { task_name: newTaskName },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          let respData = response.data.data;
          props.addTaskList(respData);
          setNewTaskName("");
          props?.setSnackbarMsg(response.data.message);
          props?.setSnackbarOpen(true);
        })
        .catch((error) => {
          if (typeof error.response !== "undefined")
            toast.error(error.response.data.message);
          setLoading(false);
        });
    }
  };

  const removeTask = async () => {
    setLoading(true);
    setOpenTaskDeleteModal(false);
    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });
    axios
      .delete(
        process.env.REACT_APP_APPLICANT_API_URL +
        "v1/delete-task-list/" +
        props?.prospectData?.id +
        "/" +
        deleteTaskId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        props.deleteTaskList(deleteTaskId);
        props?.setSnackbarMsg(response.data.message);
        props?.setSnackbarOpen(true);
      })
      .catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      taskList,
      result.source.index,
      result.destination.index
    );
    setTaskList(items);
  };

  useEffect(() => {
    const handler = setTimeout(async () => {
      let newTaskList = taskList?.map((i) => {
        return { id: i?.id };
      });
      const token = await getAccessTokenSilently({
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      });
      if (newTaskList?.length > 0) {
        axios
          .post(
            process.env.REACT_APP_APPLICANT_API_URL +
            "v1/change-tasklist-order",
            { data: JSON.stringify(newTaskList) },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            console.log("Success");
          })
          .catch((error) => {
            console.log("Error");
          });
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [taskList, getAccessTokenSilently]);

  return (
    <>
      {loading && <Loader />}

      <div className={`${styles.TaskTabMainSec}`}>
        <div className={`${styles.TaskTabCard}`}>
          <div className={`${styles.TaskTabCardUnder}`}>
            <div className={`${styles.TaskTabCardHead}`}>
              <p class={`${styles.FormAccoHeadTitle}`}>Tasklist</p>
            </div>
            <div className={`${styles.TaskTabCardAccoRow}`}>
              <div className={`${styles.ProspectTaskTable} ProspectTaskTable`}>
                <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <table
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        <tbody>
                          {taskList.map((item, index) => (
                            <Draggable
                              key={"item-" + item.id}
                              draggableId={"item-" + item.id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <tr
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <td>
                                    {(!isShowInlineEdit ||
                                      item?.id !== editTaskData?.id) && (
                                        <>
                                          <div
                                            className={`${styles.tasklistRow}`}
                                          >
                                            <div>
                                              <FormControlLabel
                                                className={`${styles.ProsCheckSec}`}
                                                control={
                                                  <Checkbox
                                                    checked={
                                                      item?.is_checked === 1
                                                    }
                                                    onChange={(e) =>
                                                      checkChagneNew(e, item)
                                                    }
                                                  />
                                                }
                                              />
                                              <p
                                                onClick={(e) => {
                                                  if (item?.is_primary) {
                                                    return;
                                                  }
                                                  setShowInlineEdit(true);
                                                  setShowAddAction(false);
                                                  setEditTaskData(item);
                                                  setNewTaskName(item?.task_name);
                                                }}
                                              >
                                                {item?.is_checked === 0 && (
                                                  <>{item?.task_name}</>
                                                )}
                                                {item?.is_checked === 1 && (
                                                  <del>{item?.task_name}</del>
                                                )}
                                                {item?.is_primary === 1 && (
                                                  <Lock
                                                    className={`${styles.TaskListLockIcon}`}
                                                  />
                                                )}
                                              </p>
                                            </div>
                                            {item?.is_checked === 1 && (
                                              <p
                                                className={`${styles.completeText}`}
                                              >
                                                Complete:{" "}
                                                {dayjs(item?.completed_at).format(
                                                  "MM/DD/YYYY"
                                                )}
                                              </p>
                                            )}
                                          </div>

                                          {/*item?.is_primary !== 1 && (<Dropdown className={`${styles.ProEditSec} ${styles.Table}`}>
                                <Dropdown.Toggle className={`${styles.EditActionsBU} ${styles.Table} ProsDrBU`} id="dropdown-basic">
                                  <MoreVertical />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                  <Dropdown.Item
                                    className={`${styles.EditActionsBUListItem}`}
                                    onClick={(e) => {
                                      setShowInlineEdit(true);
                                      setShowAddAction(false);
                                      setEditTaskData(item);
                                      setNewTaskName(item?.task_name);
                                    }}
                                  >
                                    <Edit2 /> Edit
                                  </Dropdown.Item>
                                  {taskList?.length > 2 && (<Dropdown.Item
                                    className={`${styles.EditActionsBUListItem} ${styles.Delete}`}
                                    onClick={(e) => {
                                      setOpenTaskDeleteModal(true);
                                      setDeleteTaskId(item?.id);
                                    }}
                                  >
                                    <Trash2 /> Delete
                                  </Dropdown.Item>)}
                                </Dropdown.Menu>
                              </Dropdown>)*/}
                                        </>
                                      )}

                                    {isShowInlineEdit &&
                                      item?.id === editTaskData?.id && (
                                        <div
                                          className={`${styles.EditActionSec}`}
                                        >
                                          <div
                                            className={`${styles.EditActionFormSec} FormGroup`}
                                          >
                                            <TextField
                                              id="outlined-basic"
                                              label="Task Name"
                                              variant="outlined"
                                              value={newTaskName}
                                              onChange={(e) =>
                                                setNewTaskName(e.target.value)
                                              }
                                            />
                                          </div>
                                          <div
                                            className={`${styles.EditActionButtonSec}`}
                                          >
                                            <button
                                              className={`${styles.EditActionButtonUpdate}`}
                                              onClick={(e) => {
                                                addNewTask();
                                              }}
                                            >
                                              Update
                                            </button>
                                            <button
                                              className={`${styles.EditActionButtonCancel}`}
                                              onClick={(e) => {
                                                setShowInlineEdit(false);
                                              }}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          ))}

                          {isShowAddAction && (
                            <tr>
                              <td>
                                <div className={`${styles.EditActionSec}`}>
                                  <div
                                    className={`${styles.EditActionFormSec} FormGroup`}
                                  >
                                    <TextField
                                      id="outlined-basic"
                                      label="Task Name"
                                      variant="outlined"
                                      value={newTaskName}
                                      onChange={(e) =>
                                        setNewTaskName(e.target.value)
                                      }
                                    />
                                  </div>
                                  <div
                                    className={`${styles.EditActionButtonSec}`}
                                  >
                                    <button
                                      className={`${styles.EditActionButtonUpdate}`}
                                      onClick={(e) => {
                                        addNewTask();
                                      }}
                                    >
                                      Add
                                    </button>
                                    <button
                                      className={`${styles.EditActionButtonCancel}`}
                                      onClick={(e) => {
                                        setShowInlineEdit(false);
                                        setShowAddAction(false);
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                          {provided.placeholder}
                          {/*taskList?.length < 10 && (<tr>
                        <td className={`${styles.AddChecklistTD}`}>
                          <button className={`${styles.AddChecklistBu}`} onClick={(e) => { setEditTaskData(null); setNewTaskName(""); setShowInlineEdit(false); setShowAddAction(true); }}><Plus /> Add a task</button>
                        </td>
                      </tr>)*/}
                        </tbody>
                      </table>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>

              {showSubmitButtonNew && (
                <div
                  className={`${styles.CheckApplyBU}`}
                  onClick={(e) => changeTaskList()}
                >
                  <button type="button">Apply</button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={`${styles.TaskTabCard} ${styles.TaskRowHalf}`}>
          <div
            className={`${styles.TaskTabCardUnder} ${styles.TaskTabCardUnderHalf}`}
          >
            <div className={`${styles.TaskTabCardHead}`}>
              <p class={`${styles.FormAccoHeadTitle}`}>Tours</p>
              {props?.prospectData?.tours?.length > 0 && (<button className={`${styles.AddLeaseBUTwo}`}
                onClick={(e) => {
                  props.setAddTourModalOpen(true);
                  props.setTourTimeSlotError("");
                  props.setEditTourData(null);
                }}
              >
                <Plus /> Add Tour
              </button>)}
            </div>
            {props?.prospectData?.tours?.length > 0 && (
              <div className={`${styles.TaskTabCardAccoRow}`}>
                {props?.prospectData?.tours?.map((item) => {
                  return (
                    <div className={`${styles.TaskTabTourList}`}>
                      <div className={`${styles.TourNameSec}`}>
                        <p className={`${styles.Emoji}`}>
                          {item?.user_initial}
                        </p>
                        <div>
                          <p class={`${styles.TourCretorName}`}>
                            {item?.user_fullname}
                          </p>
                          <p class={`${styles.TourCretorDate}`}>
                            {item?.formatted_date}{" "}
                            <span>{item?.formatted_time}</span>
                          </p>
                        </div>
                      </div>
                      <div className={`${styles.TaskTabTourListActionSec}`}>
                        <FormControlLabel
                          className={`${styles.ProsCheckSec}`}
                          control={
                            <Checkbox
                              defaultChecked={item?.is_completed === 1}
                              onChange={cngTourCheck.bind(this, item?.id)}
                              disabled={
                                !(
                                  isAuthenticated &&
                                  user[
                                    "https://propertydek.com/permissions"
                                  ].indexOf("prospect-tour:update") > -1
                                )
                              }
                            />
                          }
                        />
                        {item?.is_completed === 1 && (
                          <span className={`${styles.TourcompletedBadge}`}>
                            Completed
                          </span>
                        )}
                        {item?.is_completed === 0 &&
                          item?.is_confirmed === 1 && (
                            <span className={`${styles.TourconfirmedBadge}`}>
                              Confirmed
                            </span>
                          )}
                        {item?.is_completed === 0 &&
                          item?.is_confirmed === 0 && (
                            <span className={`${styles.TourpendingBadge}`}>
                              Pending
                            </span>
                          )}
                        {isAuthenticated &&
                          (user["https://propertydek.com/permissions"].indexOf(
                            "prospect-tour:update"
                          ) > -1 ||
                            user["https://propertydek.com/permissions"].indexOf(
                              "prospect-tour:delete"
                            ) > -1) && (
                            <Dropdown className={`${styles.ProEditSec}`}>
                              <Dropdown.Toggle
                                className={`${styles.EditActionsBU} ${styles.Table} ProsDrBU`}
                                id="dropdown-basic"
                              >
                                <MoreVertical />
                              </Dropdown.Toggle>

                              <Dropdown.Menu
                                className={`${styles.ActionsBUList} ActionsBUList`}
                              >
                                {isAuthenticated &&
                                  user[
                                    "https://propertydek.com/permissions"
                                  ].indexOf("prospect-tour:update") > -1 && (
                                    <Dropdown.Item
                                      className={`${styles.EditActionsBUListItem}`}
                                      onClick={(e) => {
                                        props?.setAddTourModalOpen(true);
                                        props?.setEditTourData(item);
                                      }}
                                    >
                                      <Edit2 /> Edit
                                    </Dropdown.Item>
                                  )}
                                {isAuthenticated &&
                                  user[
                                    "https://propertydek.com/permissions"
                                  ].indexOf("prospect-tour:delete") > -1 && (
                                    <Dropdown.Item
                                      className={`${styles.EditActionsBUListItem} ${styles.Delete}`}
                                      onClick={(e) => {
                                        setOpenDeleteModal(true);
                                        setDeleteId(item?.id);
                                      }}
                                    >
                                      <Trash2 /> Delete
                                    </Dropdown.Item>
                                  )}
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <div>
              {props?.prospectData?.tours?.length === 0 && (
                <div className={`${styles.NotesRow}`}>
                  <div className={`${styles.NoDataMain}`}>
                    <div className={`${styles.NoDataIMG}`}>
                      <img src="/static/img/NoTaskFound.png" alt="" />
                    </div>
                    <p className={`${styles.NoDataText}`}>Ready to go on a tour?</p>
                    <p className={`${styles.NoDataTextSub}`}>Plan your first tour to get started.</p>
                    {isAuthenticated &&
                      user["https://propertydek.com/permissions"].indexOf(
                        "prospect-tour:create"
                      ) > -1 && (
                        <button
                          className={`${styles.AddLeaseBU}`}
                          onClick={(e) => {
                            props.setAddTourModalOpen(true);
                            props.setTourTimeSlotError("");
                            props.setEditTourData(null);
                          }}
                        >
                          <Plus /> Add Tour
                        </button>
                      )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            className={`${styles.TaskTabCardUnder} ${styles.TaskTabCardUnderHalf}`}
          >
            <div className={`${styles.TaskTabCardHead}`}>
              <p class={`${styles.FormAccoHeadTitle}`}>Follow-Up List</p>
              {props?.followUpList?.length > 0 && (<button className={`${styles.AddLeaseBUTwo}`} onClick={(e) => { props.setOpenFollowUpModal(true); }}>
                <Bell /> Set Follow-Up
              </button>)}
            </div>
            <FollowUpList
              setFollowUpList={props?.setFollowUpList.bind(this)}
              followUpList={props?.followUpList}
              setFollowUpEditData={props?.setFollowUpEditData}
              setLoading={setLoading}
              setSnackbarMsg={props?.setSnackbarMsg}
              setSnackbarOpen={props?.setSnackbarOpen}
              setOpenFollowUpModal={props?.setOpenFollowUpModal.bind(this)}
            />
          </div>
        </div>
      </div>

      {/* <div className="FormAccording ProspectTask Theme">
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <div className={`${styles.FormAccoHead}`}>
              <p className={`${styles.FormAccoHeadTitle}`}>Tasklist</p>
            </div>
          </AccordionSummary>
          <AccordionDetails className={`${styles.CussAccoRow}`}>
            <div className={`${styles.ProspectTaskTable} ProspectTaskTable`}>
              <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => (
                    <table
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      // style={getListStyle(snapshot.isDraggingOver)}
                    >
                      <tbody>
                        <tr>
                          <th>Actions</th>
                        </tr>
                        {taskList.map((item, index) => (
                          <Draggable
                            key={"item-" + item.id}
                            draggableId={"item-" + item.id}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <tr
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                // style={getItemStyle(
                                //   snapshot.isDragging,
                                //   provided.draggableProps.style
                                // )}
                              >
                                <td>
                                  {(!isShowInlineEdit ||
                                    item?.id !== editTaskData?.id) && (
                                    <span>
                                      <p
                                        className={`${styles.TableSmallTitle}`}
                                      >
                                        Actions
                                      </p>

                                      <div className={`${styles.tasklistRow}`}>
                                        <div>
                                          <FormControlLabel
                                            className={`${styles.ProsCheckSec}`}
                                            control={
                                              <Checkbox
                                                checked={item?.is_checked === 1}
                                                onChange={(e) =>
                                                  checkChagneNew(e, item)
                                                }
                                              />
                                            }
                                          />
                                          <p
                                            onClick={(e) => {
                                              setShowInlineEdit(true);
                                              setShowAddAction(false);
                                              setEditTaskData(item);
                                              setNewTaskName(item?.task_name);
                                            }}
                                          >
                                            {item?.task_name}
                                          </p>
                                        </div>
                                        {item?.is_checked === 1 && (
                                          <p
                                            className={`${styles.completeText}`}
                                          >
                                            Complete:{" "}
                                            {dayjs(item?.completed_at).format(
                                              "MM/DD/YYYY"
                                            )}
                                          </p>
                                        )}
                                      </div>

                                      <Dropdown
                                        className={`${styles.ProEditSec} ${styles.Table}`}
                                      >
                                        <Dropdown.Toggle
                                          className={`${styles.EditActionsBU} ${styles.Table} ProsDrBU`}
                                          id="dropdown-basic"
                                        >
                                          <MoreVertical />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu
                                          className={`${styles.ActionsBUList} ActionsBUList`}
                                        >
                                          <Dropdown.Item
                                            className={`${styles.EditActionsBUListItem}`}
                                            onClick={(e) => {
                                              setShowInlineEdit(true);
                                              setShowAddAction(false);
                                              setEditTaskData(item);
                                              setNewTaskName(item?.task_name);
                                            }}
                                          >
                                            <Edit2 /> Edit
                                          </Dropdown.Item>
                                          {taskList?.length > 2 && (
                                            <Dropdown.Item
                                              className={`${styles.EditActionsBUListItem} ${styles.Delete}`}
                                              onClick={(e) => {
                                                setOpenTaskDeleteModal(true);
                                                setDeleteTaskId(item?.id);
                                              }}
                                            >
                                              <Trash2 /> Delete
                                            </Dropdown.Item>
                                          )}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </span>
                                  )}
                                  {isShowInlineEdit &&
                                    item?.id === editTaskData?.id && (
                                      <div
                                        className={`${styles.EditActionSec}`}
                                      >
                                        <div
                                          className={`${styles.EditActionFormSec} FormGroup`}
                                        >
                                          <TextField
                                            id="outlined-basic"
                                            label="Task Name"
                                            variant="outlined"
                                            value={newTaskName}
                                            onChange={(e) =>
                                              setNewTaskName(e.target.value)
                                            }
                                          />
                                        </div>
                                        <div
                                          className={`${styles.EditActionButtonSec}`}
                                        >
                                          <button
                                            className={`${styles.EditActionButtonUpdate}`}
                                            onClick={(e) => {
                                              addNewTask();
                                            }}
                                          >
                                            Update
                                          </button>
                                          <button
                                            className={`${styles.EditActionButtonCancel}`}
                                            onClick={(e) => {
                                              setShowInlineEdit(false);
                                            }}
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                </td>
                              </tr>
                            )}
                          </Draggable>
                        ))}
                        {isShowAddAction && (
                          <tr>
                            <td>
                              <div className={`${styles.EditActionSec}`}>
                                <div
                                  className={`${styles.EditActionFormSec} FormGroup`}
                                >
                                  <TextField
                                    id="outlined-basic"
                                    label="Task Name"
                                    variant="outlined"
                                    value={newTaskName}
                                    onChange={(e) =>
                                      setNewTaskName(e.target.value)
                                    }
                                  />
                                </div>
                                <div
                                  className={`${styles.EditActionButtonSec}`}
                                >
                                  <button
                                    className={`${styles.EditActionButtonUpdate}`}
                                    onClick={(e) => {
                                      addNewTask();
                                    }}
                                  >
                                    Add
                                  </button>
                                  <button
                                    className={`${styles.EditActionButtonCancel}`}
                                    onClick={(e) => {
                                      setShowInlineEdit(false);
                                      setShowAddAction(false);
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                        {provided.placeholder}
                        {taskList?.length < 10 && (
                          <tr>
                            <td className={`${styles.AddChecklistTD}`}>
                              <button
                                className={`${styles.AddChecklistBu}`}
                                onClick={(e) => {
                                  setEditTaskData(null);
                                  setNewTaskName("");
                                  setShowInlineEdit(false);
                                  setShowAddAction(true);
                                }}
                              >
                                <Plus />
                                Add a task
                              </button>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
            {showSubmitButtonNew && (
              <div
                className={`${styles.CheckApplyBU}`}
                onClick={(e) => changeTaskList()}
              >
                <button type="button">Apply</button>
              </div>
            )}
          </AccordionDetails>
        </Accordion>

        {isAuthenticated &&
          user["https://propertydek.com/permissions"].indexOf(
            "prospect-tour:read"
          ) > -1 && (
            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2bh-content"
                id="panel2bh-header"
              >
                <div className={`${styles.FormAccoHead}`}>
                  <p className={`${styles.FormAccoHeadTitle}`}>Tours</p>
                </div>
              </AccordionSummary>
              <AccordionDetails className={`${styles.CussAccoRow}`}>
                <div
                  className={`${styles.ProspectTaskTable} ${styles.Tour} ProspectTaskTable`}
                >
                  {props?.prospectData?.tours?.length > 0 && (
                    <table>
                      <tbody>
                        <tr>
                          <th>Created By</th>
                          <th>Date</th>
                          <th>Completed</th>
                        </tr>
                        {props?.prospectData?.tours?.map((item) => {
                          return (
                            <tr>
                              <td>
                                <div className={`${styles.TourNameSec}`}>
                                  <p className={`${styles.Emoji}`}>
                                    {item?.user_initial}
                                  </p>
                                  <p className={`${styles.TourCretorName}`}>
                                    {item?.user_fullname}
                                  </p>
                                </div>
                              </td>
                              <td>
                                <p>
                                  {item?.formatted_date}
                                  <span>{item?.formatted_time}</span>
                                </p>
                              </td>
                              <td>
                                <FormControlLabel
                                  className={`${styles.ProsCheckSec}`}
                                  control={
                                    <Checkbox
                                      defaultChecked={item?.is_completed === 1}
                                      onChange={cngTourCheck.bind(
                                        this,
                                        item?.id
                                      )}
                                      disabled={
                                        !(
                                          isAuthenticated &&
                                          user[
                                            "https://propertydek.com/permissions"
                                          ].indexOf("prospect-tour:update") > -1
                                        )
                                      }
                                    />
                                  }
                                />
                                {item?.is_completed === 1 && (
                                  <span
                                    className={`${styles.TourcompletedBadge}`}
                                  >
                                    Completed
                                  </span>
                                )}
                                {item?.is_completed === 0 &&
                                  item?.is_confirmed === 1 && (
                                    <span
                                      className={`${styles.TourconfirmedBadge}`}
                                    >
                                      Confirmed
                                    </span>
                                  )}
                                {item?.is_completed === 0 &&
                                  item?.is_confirmed === 0 && (
                                    <span
                                      className={`${styles.TourpendingBadge}`}
                                    >
                                      Pending
                                    </span>
                                  )}
                                {isAuthenticated &&
                                  (user[
                                    "https://propertydek.com/permissions"
                                  ].indexOf("prospect-tour:update") > -1 ||
                                    user[
                                      "https://propertydek.com/permissions"
                                    ].indexOf("prospect-tour:delete") > -1) && (
                                    <Dropdown
                                      className={`${styles.ProEditSec}`}
                                    >
                                      <Dropdown.Toggle
                                        className={`${styles.EditActionsBU} ${styles.Table} ProsDrBU`}
                                        id="dropdown-basic"
                                      >
                                        <MoreVertical />
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu
                                        className={`${styles.ActionsBUList} ActionsBUList`}
                                      >
                                        {isAuthenticated &&
                                          user[
                                            "https://propertydek.com/permissions"
                                          ].indexOf("prospect-tour:update") >
                                            -1 && (
                                            <Dropdown.Item
                                              className={`${styles.EditActionsBUListItem}`}
                                              onClick={(e) => {
                                                props?.setAddTourModalOpen(
                                                  true
                                                );
                                                props?.setEditTourData(item);
                                              }}
                                            >
                                              <Edit2 /> Edit
                                            </Dropdown.Item>
                                          )}
                                        {isAuthenticated &&
                                          user[
                                            "https://propertydek.com/permissions"
                                          ].indexOf("prospect-tour:delete") >
                                            -1 && (
                                            <Dropdown.Item
                                              className={`${styles.EditActionsBUListItem} ${styles.Delete}`}
                                              onClick={(e) => {
                                                setOpenDeleteModal(true);
                                                setDeleteId(item?.id);
                                              }}
                                            >
                                              <Trash2 /> Delete
                                            </Dropdown.Item>
                                          )}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                  {props?.prospectData?.tours?.length === 0 && (
                    <div className={`${styles.NotesRow}`}>
                      <div className={`${styles.NoDataMain}`}>
                        <div className={`${styles.NoDataIMG}`}>
                          <img src="/static/img/NoTaskFound.png" alt="" />
                        </div>
                        <p className={`${styles.NoDataText}`}>No Tour Found</p>
                        {isAuthenticated &&
                          user["https://propertydek.com/permissions"].indexOf(
                            "prospect-tour:create"
                          ) > -1 && (
                            <button
                              className={`${styles.AddLeaseBU}`}
                              onClick={(e) => {
                                props.setAddTourModalOpen(true);
                                props.setTourTimeSlotError("");
                                props.setEditTourData(null);
                              }}
                            >
                              <Plus /> Add Tour
                            </button>
                          )}
                      </div>
                    </div>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          )}
      </div> */}

      <Dialog
        open={openDeleteModal}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
        onClose={(e) => {
          setOpenDeleteModal(false);
          setDeleteId(0);
        }}
      >
        <DialogTitle id="alert-dialog-title">
          Delete Tour
          <button
            onClick={(e) => {
              setOpenDeleteModal(false);
              setDeleteId(0);
            }}
          >
            <X />
          </button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className="ModalFormGroup"
            style={{ marginBottom: "0px", padding: "25px 0" }}
          >
            <label className="PopupBodyText">
              Are you sure you want to delete this item?
            </label>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="CancelPopupBU"
            onClick={(e) => {
              deleteConfirm();
            }}
          >
            Delete
          </Button>
          <Button
            className="SubmitPopupBU"
            onClick={(e) => {
              setOpenDeleteModal(false);
              setDeleteId(0);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAddTaskModal}
        fullWidth
        maxWidth="xs"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
        onClose={(e) => {
          setOpenAddTaskModal(false);
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {editTaskData ? "Edit Task" : "Add Task"}
          <button
            onClick={(e) => {
              setOpenAddTaskModal(false);
            }}
          >
            <X />
          </button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className="ModalFormGroup"
          >
            <div className={`${styles.EditFormFullSec} FormGroup`}>
              <TextField
                label="Task Name"
                variant="outlined"
                value={newTaskName}
                onChange={(e) => setNewTaskName(e.target.value)}
              />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="CancelPopupBU"
            onClick={(e) => {
              setOpenAddTaskModal(false);
            }}
          >
            Cancel
          </Button>
          <Button
            className="SubmitPopupBU"
            onClick={(e) => {
              addNewTask();
            }}
          >
            {editTaskData ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openTaskDeleteModal}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
        onClose={(e) => {
          setOpenTaskDeleteModal(false);
          setDeleteTaskId(0);
        }}
      >
        <DialogTitle id="alert-dialog-title">
          Delete Task
          <button
            onClick={(e) => {
              setOpenTaskDeleteModal(false);
              setDeleteTaskId(0);
            }}
          >
            <X />
          </button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className="ModalFormGroup"
            style={{ marginBottom: "0px", padding: "25px 0" }}
          >
            <label className="PopupBodyText">
              Are you sure you want to delete this item?
            </label>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="CancelPopupBU"
            onClick={(e) => {
              removeTask();
            }}
          >
            Delete
          </Button>
          <Button
            className="SubmitPopupBU"
            onClick={(e) => {
              setOpenTaskDeleteModal(false);
              setDeleteTaskId(0);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TaskTab;
